// FILE: client/src/components/VoiceButton.js

import React from "react";

export default function VoiceButton({
  micOn,
  voiceConnected,
  disabled,
  onToggle,
}) {
  const glow = micOn
    ? "0 0 0 2px rgba(34,197,94,0.35), 0 0 22px rgba(34,197,94,0.55)"
    : "0 0 0 2px rgba(255,255,255,0.10)";

  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={disabled}
      title={micOn ? "Mic ON (tap to mute)" : "Mic OFF (tap to talk)"}
      style={{
        position: "fixed",
        right: 18,
        bottom: 120, // above HostControls pill
        zIndex: 9999,
        width: 56,
        height: 56,
        borderRadius: 999,
        border: "1px solid rgba(255,255,255,0.18)",
        background: micOn
          ? "linear-gradient(180deg, rgba(34,197,94,0.35), rgba(16,185,129,0.18))"
          : "linear-gradient(180deg, rgba(255,255,255,0.10), rgba(255,255,255,0.06))",
        color: "white",
        boxShadow: glow,
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
      }}
    >
      <span style={{ fontSize: 22, lineHeight: 1 }}>
        {micOn ? "🎤" : "🔇"}
      </span>

      {/* Tiny connected dot (optional but useful) */}
      <span
        aria-hidden="true"
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          width: 10,
          height: 10,
          borderRadius: 999,
          background: voiceConnected ? "rgba(34,197,94,0.95)" : "rgba(255,255,255,0.25)",
          boxShadow: voiceConnected ? "0 0 10px rgba(34,197,94,0.7)" : "none",
        }}
      />
    </button>
  );
}
